import gql from 'graphql-tag';

export const createVisitorCustomFieldConfig = gql`
  mutation CreateVisitorCustomFieldConfig($config: VisitorCustomFieldConfigInput!) {
    createVisitorCustomFieldConfig(config: $config) {
      id
      organizationId
      fieldKey
      fieldName
      fieldType
      isEnabled
      options
      placeholder
      validationRegex
      createdAtDatetime
      updatedAtDatetime
      createdByUserId
      updatedByUserId
    }
  }
`;
